import { paintColors, woodColors } from "./colors.js";
export const colors = paintColors;
export const floorColors = woodColors;

export const range = {
    seamSize: {
        min: 0,
        max: 10,
    },
    tileWidth: {
        min: 10,
        max: 100,
    },
    tileHeight: {
        min: 10,
        max: 100,
    },

    carpetWidth: {
        min: 100,
        max: 340,
    },
    carpetHeight: {
        min: 100,
        max: 490,
    },
};

export const initialSettings = {
    seamSize: 1.5,
    tileWidth: 30,
    tileHeight: 30,
    material: "polish",
    carpetWidth: 340,
    carpetHeight: 490,
    seamColor: colors[0],
    texture: null,
    normalMap: null,
    isTile: true,
    pos: "horizontal",
    turned: false,
    options: "tile",
    carpet: null,
    inches: 6,
    length: 2,
    floorRotate: 0,
    floorColor: floorColors[0],
    isPlastic: false,
    rollWidth: 60,
};

export const lightTemperatures = ["rgb(255, 250, 225)", "rgb(255, 255, 255)", "rgb(230, 240, 252)"];
